import axios from "axios"
import { saveAs } from "file-saver"
import { uploadR2File } from "@/services/r2UploadService"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
export default {
  toDoList: {
    fetchOmaUsers() {
      return axios.get(buildUrl("todo/oma-users"), buildOptions()).then((res) => res.data)
    },
    fetchMarketingTeamUsers() {
      return axios.get(buildUrl("todo/marketing-team-users"), buildOptions()).then((res) => res.data)
    },
    markSeen(id) {
      return axios.put(buildUrl(`todo/${id}/seen`), {}, buildOptions()).then((res) => res.data)
    },
    setInactive(id, data) {
      return axios.put(buildUrl(`todo/${id}/inactive`), data, buildOptions()).then((res) => res.data)
    },
    downloadAttachment(todoId, attachmentId) {
      return axios.get(buildUrl(`todo/${todoId}/attachment/${attachmentId}/download`), buildOptions({ responseType: "blob" }))
        .then((res) => ({ blob: res.data, name: decodeURIComponent(res.headers["x-download-name"] || "Anhang") }))
    },
    fetchMarketingEvents() {
      return axios.get(buildUrl("todo/marketing-events"), buildOptions()).then((res) => res.data)
    },
    // NEU: Holt die Liste für das Dropdown
    fetchMarketingHolidayOptions(year) {
      let params = {}
      if (year) params.year = year
      return axios.get(buildUrl("todo/marketing-holiday-options"), buildOptions({ params })).then((res) => res.data)
    },
    createMarketingEvent(data) {
      return axios.post(buildUrl("todo/marketing-events"), data, buildOptions()).then((res) => res.data)
    },
    updateMarketingEvent(id, data) {
      return axios.put(buildUrl(`todo/marketing-events/${id}`), data, buildOptions()).then((res) => res.data)
    },
    deleteMarketingEvent(id) {
      return axios.delete(buildUrl(`todo/marketing-events/${id}`), buildOptions()).then((res) => res.data)
    },
    deleteAttachment(data) {
      let url = buildUrl(`todo/attachment/${data._id}/${data.attachmentId}`)
      return axios.delete(url, buildOptions()).then((res) => res.data)
    },
    fetchAttachment(uri, asBase64 = true) {
      let url = buildUrl(uri)

      return axios.get(url, buildOptions({ responseType: "blob" })).then((res) => {
        if (asBase64) {
          // Für Bilder: in Base64 umwandeln
          return blobToBase64(res.data)
        }
        // Für andere Dateien: Den Blob direkt zurückgeben
        return res.data
      })
    },
    prepareAttachmentUpload(id, file) {
      return axios.post(buildUrl(`todo/${id}/attachments/uploads`), {
        fileName: file.name, mimeType: file.type, size: file.size,
      }, buildOptions()).then((res) => res.data)
    },
    completeAttachmentUpload(id, session) {
      return axios.post(buildUrl(`todo/${id}/attachments/uploads/complete`), {
        objectKey: session.objectKey, sessionToken: session.sessionToken,
      }, buildOptions()).then((res) => res.data)
    },
    cancelAttachmentUpload(id, session) {
      return axios.delete(buildUrl(`todo/${id}/attachments/uploads`), buildOptions({ data: {
        objectKey: session.objectKey, sessionToken: session.sessionToken,
      } })).then((res) => res.data)
    },
    getAttachmentUrl(id, attachmentId, preview = false) {
      return axios.get(buildUrl(`todo/${id}/attachment/${attachmentId}/url`), buildOptions({ params: preview ? { preview: true } : {} })).then((res) => res.data)
    },
    previewAttachment(id, attachmentId) {
      return axios.get(buildUrl(`todo/${id}/attachment/${attachmentId}/preview`), buildOptions({ responseType: "blob" })).then((res) => res.data)
    },
    async uploadAttachment(formData, toDoId) {
      // Keep the existing caller contract (including the COO dashboard), but store new files in R2.
      const file = formData.get("file")
      if (!file) throw new Error("Bitte eine Datei auswählen.")
      const session = await this.prepareAttachmentUpload(toDoId, file)
      try {
        await uploadR2File(file, session)
        return await this.completeAttachmentUpload(toDoId, session)
      } catch (error) {
        // The server retains a file if an uncertain completion response actually succeeded.
        await this.cancelAttachmentUpload(toDoId, session).catch(() => {})
        throw error
      }
    },
    addVideoLink(id, data) {
      let url = buildUrl(`todo/${id}/videolink`)
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    deleteImage(data) {
      let url = buildUrl("todo/image/" + data._id + "/" + data.imageIndex)
      return axios.delete(url, buildOptions()).then((res) => res.data)
    },
    fetchImage(uri) {
      let url = buildUrl(uri)

      // fetch response as a blob
      return axios.get(url, buildOptions({ responseType: "blob" })).then((res) => {
        // convert blob to base64 string
        return blobToBase64(res.data).then((base64) => {
          return base64
        })
      })
    },
    uploadImages(formData, toDoId) {
      let url = buildUrl("todo/image/" + toDoId)
      return axios.post(url, formData, buildOptions()).then((res) => res.data)
    },
    // GET
    fetchAll(params = {}) {
      let url = buildUrl("todo")
      return axios.get(url, buildOptions({ params })).then((res) => res.data)
    },
    fetchAllCoo(params = {}) {
      let url = buildUrl("todocoo")
      return axios.get(url, buildOptions({ params })).then((res) => res.data)
    },
    create(data) {
      let url = buildUrl("todo")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    update(id, data) {
      let url = buildUrl(`todo/${id}`)
      return axios.put(url, data, buildOptions()).then((res) => res.data)
    },
    delete(id) {
      let url = buildUrl(`todo/${id}`)
      return axios.delete(url, buildOptions()).then((res) => res.data)
    },
    addComment(id, data) {
      let url = buildUrl(`todo/${id}/comment`)
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    assign(id, data) {
      let url = buildUrl(`todo/${id}/assign`)
      return axios.put(url, data, buildOptions()).then((res) => res.data)
    },
    removeAssignment(id, userId) {
      let url = buildUrl(`todo/${id}/assign/${userId}`)
      return axios.delete(url, buildOptions()).then((res) => res.data)
    },
  },
}
